import { render, staticRenderFns } from "./StationResearch.vue?vue&type=template&id=5bc74b3e&scoped=true&"
import script from "./StationResearch.vue?vue&type=script&lang=js&"
export * from "./StationResearch.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/project-detail.css?vue&type=style&index=0&id=5bc74b3e&scoped=true&lang=css&"
import style1 from "./StationResearch.vue?vue&type=style&index=1&id=5bc74b3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc74b3e",
  null
  
)

export default component.exports